import { GuxTagAccent } from "genesys-spark-components";
import { ReactNode } from "react";

import { GuxBadge, GuxTag } from "genesys-spark-components-react";
import TagAccent from "enums/TagAccent";

export type ScoreTagLevel = "default" | "critical" | "info" | "fatal";

const colors: { [key in ScoreTagLevel]?: GuxTagAccent } = {
    default: "4",
    critical: "8",
    info: "1",
    fatal: undefined,
};

export function ScoreTag({
    children,
    mode = "default",
    selected = true,
    ariaLabel,
}: {
    children: ReactNode;
    mode?: ScoreTagLevel;
    selected?: boolean;
    ariaLabel?: string;
}) {
    const tagAccent = mode === "default" ? TagAccent.FLARE : colors[mode];

    const tag =
        mode === "fatal" ? (
            <GuxBadge
                accent="error"
                bold={selected}
                className="ScoreTag"
                aria-hidden={ariaLabel ? "true" : undefined}
            >
                {children}
            </GuxBadge>
        ) : (
            <GuxTag
                className="ScoreTag"
                accent={tagAccent}
                emphasis={selected ? "bold" : "subtle"}
                aria-hidden={ariaLabel ? "true" : undefined}
            >
                {children}
            </GuxTag>
        );

    return ariaLabel ? (
        <span role="img" aria-label={ariaLabel}>
            {tag}
        </span>
    ) : (
        tag
    );
}
